import { DateTime } from 'luxon'
import { computed, Ref, ref, watch } from 'vue'
import Sector from '@/types/Sector'
import EventService from '@/services/EventService'
import { DataTableFilter } from '@/types/DataTable'

interface SectorFilterPayload {
  event: Ref<string | null>
  label: string
  field: string
  multiple?: boolean
}

export function useSectorFilter({ event, label, field, multiple }: SectorFilterPayload): DataTableFilter<string> {
  const model: Ref<string | null> = ref(null)

  const loading = ref(false)

  const expires = ref<DateTime>()

  const items: Ref<Sector[]> = ref([])

  const ready = Promise.withResolvers<boolean>()

  const load = async () => {
    if (event.value === null) return

    loading.value = true

    const service = new EventService()

    const response = await service.sectors(event.value)

    items.value = response.data

    expires.value = DateTime.now().plus({ minutes: 5 })

    ready.resolve(true)
    loading.value = false
  }

  watch(event, () => load(), { immediate: true })

  return {
    model,
    value: computed(() => model.value),
    items: computed(
      () => {
        if (expires.value !== undefined && DateTime.now() > expires.value) {
          load()
        }

        return items.value.map(i => ({ title: i.name, value: i.id }))
      },
    ),
    label,
    field,
    type: 'autocomplete',
    multiple,
    loading,
    required: false,
    ready: ready.promise,
  }
}
